<template>
    <div v-frag>
        <CardIeaAppMain colorCard="#2D3436" title="">
            <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
                <v-btn class="mx-2" fab dark small color="success" @click="$router.go(-1)">
                    <v-icon dark>
                        mdi-keyboard-backspace
                    </v-icon>
                </v-btn>
                <br /><br />
                <div class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary-text mb-3">{{ title }}</div>
                <div v-frag>
                    <div>
                        <v-simple-table>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-center">Materia</th>
                                        <th class="text-center">Nombre del Test</th>
                                        <th class="text-center">Tipo</th>
                                        <th class="text-center">Fecha</th>
                                        <th class="text-center">Hora</th>
                                        <th class="text-center">Test (BETA)</th>
                                        <th class="text-center">EN DESARROLLO</th>
                                        <th class="text-center">Nota</th>
                                        <th class="text-center">Link Test</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(test, keyTable) in examenes_data" :key="keyTable">
                                        <td>
                                            {{
                                                $vuetify.breakpoint.name == "xs"
                                                    ? test.nombreMateria
                                                    : test.nombreMateria
                                            }}
                                        </td>
                                        <td>
                                            {{
                                                $vuetify.breakpoint.name == "xs"
                                                    ? test.titulo
                                                    : test.titulo
                                            }}
                                        </td>
                                        <td>
                                            <div v-if="test.tipo_examen != null">
                                                {{ test.tipo_examen }}
                                            </div>

                                            <div v-else>Practica</div>
                                        </td>
                                        <td>
                                            <div v-if="test.tipo != 'Practica'">
                                                <span class="font-weight-black red--text">
                                                    Periodo Valido <br />
                                                    {{ test.fecha_test_desde }} /
                                                    {{ test.fecha_test_hasta }}
                                                </span>
                                            </div>
                                        </td>
                                        <td>
                                            <div v-if="test.tipo != 'Practica'">
                                                <span class="font-weight-black red--text">
                                                    Horario Valido <br />
                                                    {{ test.hora_inicio }} a
                                                    {{ test.hora_final }}
                                                </span>
                                            </div>
                                        </td>
                                        <td v-if="test.tipo == 'Practica'">
                                            <div v-frag>
                                                <v-btn @click="linkTest(test)" small
                                                    class="info--text text-decoration-underline font-weight-regular"
                                                    depressed text color="info">Presentar Test</v-btn>
                                            </div>
                                        </td>
                                        <td v-else-if="test.tipo == 'Examen Final'">
                                            <div v-if="
                                                test.tipo_examen == 'Recuperatorio' &&
                                                test.presentarExamenRecuperatorio
                                            ">
                                                <div v-frag v-if="
                                                    test.testPresentado == false &&
                                                    puedeRendirExamen(test) == true
                                                ">
                                                    <v-btn @click="linkTest(test)" small
                                                        class="info--text text-decoration-underline font-weight-regular"
                                                        depressed text color="info">Presentar Test</v-btn>
                                                </div>

                                                <div v-else-if="
                                                    puedeRendirExamen(test) == false
                                                ">
                                                    <v-btn small color="danger">Test Cerrado</v-btn>
                                                </div>

                                                <div v-frag v-else>
                                                    <v-btn small color="success">Test Presentado</v-btn>
                                                </div>
                                            </div>

                                            <div v-else-if="
                                                test.tipo_examen === 'Examen Final' &&
                                                test.presentarExamenFinal === true
                                            ">
                                                <div v-frag v-if="
                                                    test.testPresentado == false &&
                                                    puedeRendirExamen(test) == true
                                                ">
                                                    <v-btn @click="linkTest(test)" small
                                                        class="info--text text-decoration-underline font-weight-regular"
                                                        depressed text color="info">Presentar Test</v-btn>
                                                </div>

                                                <div v-else-if="
                                                    puedeRendirExamen(test) == false
                                                ">
                                                    <v-btn small color="danger">Test Cerrado</v-btn>
                                                </div>

                                                <div v-frag v-else>
                                                    <v-btn small color="success">Test Presentado</v-btn>
                                                </div>
                                            </div>

                                            <div v-else-if="
                                                test.tipo_examen == '2do Parcial' ||
                                                test.tipo_examen == '1er Parcial'
                                            ">
                                                <div v-frag v-if="
                                                    test.testPresentado == false &&
                                                    puedeRendirExamen(test) == true
                                                ">
                                                    <v-btn @click="linkTest(test)" small
                                                        class="info--text text-decoration-underline font-weight-regular"
                                                        depressed text color="info">Presentar Test</v-btn>
                                                </div>

                                                <div v-else-if="
                                                    puedeRendirExamen(test) == false
                                                ">
                                                    <v-btn small color="danger">Test Cerrado</v-btn>
                                                </div>

                                                <div v-frag v-else>
                                                    <v-btn small color="success">Test Presentado</v-btn>
                                                </div>
                                            </div>
                                        </td>

                                        <td>
                                            <v-btn :href="test.url_meet" small
                                                class="info--text text-decoration-underline font-weight-regular"
                                                depressed text color="info">Ver Aquí</v-btn>
                                        </td>

                                        <td>
                                            <div v-if="test.mostrar_nota">
                                                <div v-if="test.nota >= 4">
                                                    <div class="my-2">
                                                        <v-btn color="success" fab x-small dark>
                                                            {{ test.nota }}
                                                        </v-btn>
                                                    </div>
                                                </div>
                                                <div v-else>
                                                    <div class="my-2">
                                                        <v-btn color="error" fab x-small dark>
                                                            {{ test.nota }}
                                                        </v-btn>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>

                                        <td>
                                            <div v-if="
                                                test.examen_url != null &&
                                                haPasadoMasDeUnDia(test.fecha_carga) ==
                                                false
                                            ">
                                                <div>
                                                    <div class="my-2">
                                                        <v-btn :href="test.examen_url" target="_blank" small
                                                            class="info--text text-decoration-underline font-weight-regular"
                                                            depressed text color="info">Ver Aquí</v-btn>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </div>
                </div>
            </v-col>
        </CardIeaAppMain>
    </div>
</template>
<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";
import moment from "moment";
moment.locale("es");

// Configurar la zona horaria para todas las instancias de moment
moment.fn.toJSON = function () {
    return this.format();
};
moment.parseZone = function (input) {
    return moment(input).utcOffset(-180); // Argentina UTC-3
};
export default {
    name: "ParcialExamen",
    components: {
        CardIeaAppMain
    },
    data() {
        return {
            title: 'Parciales y Exámenes Finales',
            examenes_data: []
        }
    },
    computed: {
        user() {
            return this.$store.getters.user;
        }
    },
    methods: {
        async examenes() {
            await this.$API
                .get({
                    url: "examenes",
                    data: {}
                })
                .then(res => {
                    this.examenes_data = res;

                    // console.log("panel 6", this.panels[6]);
                });
        },
        linkTest(test) {
            this.$router.push({
                name: "examen",
                params: {
                    test: test.test_id,
                    examen: test.id
                }
            });
        },
        puedeRendirExamen(examen) {
            const fechaDesde = moment(
                examen.fecha_test_desde + " " + examen.hora_inicio
            ).utcOffset(-180);
            const fechaHasta = moment(
                examen.fecha_test_hasta + " " + examen.hora_final
            ).utcOffset(-180);
            const now = moment().utcOffset(-180);

            return now.isBetween(fechaDesde, fechaHasta, null, "[]");
        },
        haPasadoMasDeUnDia(fechaCarga) {
            const fechaCargaDate = new Date(fechaCarga);
            const fechaCargaMasUnDia = new Date(
                fechaCargaDate.getTime() + 24 * 60 * 60 * 1000
            ); // Añadir un día
            const now = new Date();
            const unDia = 24 * 60 * 60 * 1000; // Milisegundos en un día

            return now - fechaCargaMasUnDia > unDia;
        },
    },
    mounted() {
        this.examenes()
    }
}
</script>